import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberBusinessProcessTodo defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberBusinessProcessTodoService } from 'services/memberBusinessProcessTodo';
 *
 * // create service instance and send/cancel request
 * const memberBusinessProcessTodoService = new MemberBusinessProcessTodoService();
 * const result = await memberBusinessProcessTodoService.fetchData( '<user-id>' ); // fetch data
 * memberBusinessProcessTodoService.cancel(); // cancel an active request
 */
export class MemberBusinessProcessTodoService extends HttpService {

    // submit form data
    async submitFormData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE )
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }
}
